import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./Auditor.css";
import AboutBanner from "../AboutBanner/AboutBanner";
import { trackEvent, trackPageView } from "../../utils/tracking";
function Auditor() {
  const [pathname, setPathName] = useState("");

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/Auditors",
      "jmf_about-us_auditors"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "Auditors Page Loaded",
      label: "jmf_about-us_auditors",
      // value: 1,
    });
  }, []);
  
  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });
  return (
    <>
      <AboutBanner />
      <section className=" trustee-sc sponsor-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/AboutUs">
                    <i>About Us</i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                {window.location.pathname != "/AboutUs" ? (
                  <li>{pathname}</li>
                ) : (
                  ""
                )}
              </ul>
              <div className="section-header">
                <h2>Auditors of the Fund</h2>
                <h5>Chokshi & Chokshi LLP</h5>
                <h6>Chartered Accountants</h6>
                <h6>
                  15/17, Raghavji B Bldg, Gowalia Tank, Off Kemps Corner, Mumbai 400 036
                </h6>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Auditor;
